<template>
	<div class="history-container">
		<h4 style="text-align: left; margin-top:1rem">Scan History</h4>
		<h5 v-if="no_history" style="margin-top:5rem">Nothing to Show</h5>
    <SearchHistory @query="updateData"/>
    <div v-for="(scanDetails, index) in dataToShow" :key="scanDetails.fileName">
			<ScanDetails
				:scanDetails="scanDetails"
        :isClosed="index !== 0"
			/>
		</div>
	</div>
</template>

<script>
import ScanDetails from '@/components/Actions/ScanDetails.vue'
import SearchHistory from '@/components/Actions/SearchHistory.vue'
import axios from 'axios'

export default {    
    name: 'Profile',
    components: { 
        ScanDetails,
        SearchHistory
    },
    data() {
        return {
          dataToShow: [],
          data: [],
          no_history: false,
        }
      },
	methods: {
		getData() {
			axios.get(process.env.VUE_APP_BACK_URL + "/"+ this.$store.getters.getUserId +"/history").then((response) => {
				if (response.data.length > 0){
					this.no_history = false
					this.data = response.data
          this.dataToShow = response.data
				} else {
					this.no_history = true
				}
			}).catch(() => {
				console.log('error happened')
			})	
		},
		updateLoc() {
			this.$store.commit('changeLoc', false)
		},
    updateData(value){
      this.dataToShow = this.data
      let tempData = this.dataToShow
      let query = value[0]
      let type = value[1]
      this.dataToShow = []
      if (tempData){
        tempData.forEach(block => {
          if (typeof block[type] === "string" && block[type].includes(query)) {
            this.dataToShow.push(block)
          } else if(type === "hash"){
            if (query.length <= 32 && block[type]["md5"].includes(query)){
              this.dataToShow.push(block)
            } else if (query.length <= 40 && block[type]["sha1"].includes(query)){
              this.dataToShow.push(block)
            } else if (query.length <= 64 && block[type]["sha256"].includes(query)){
              this.dataToShow.push(block)
            }
          } else if(type === "avResponse") {
            for (let key in block[type]) {
              if(block[type][key].includes(query) && !this.dataToShow.includes(block)){
                this.dataToShow.push(block)
              }
            }
          }
        })
      }
    }
	},
	mounted() {
		this.getData()
		this.updateLoc()
	},
}
</script>